export const MANIFEST_TYPE = {
  IFCA_Manifest: '1',
  ODF: '2',
  NCC: '1',
  WA: '3',
  VIPR: '4',
  /** base_manifest_id 5 = Project Manifest (full project details + incident position options) */
  PROJECT_MANIFEST: '5',
  DCRM: '6',
  TYPE_2: '8',
};
